import script from "./CheckVerificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckVerificationModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__